import React from "react";
import { View, Platform, StyleSheet, ScrollView, Text } from "react-native";

import Header from "../../../common/header/index";
import appStyles from "../../../../appStyles";
import appPages from "../../../../../appPages";
import AppTheme from "../../../AppTheme";
import { MoodColors } from "../../../common/mood/MoodsHelper";
import CopyWidget from '../../common/CopyWidget';

export default function Reconnect({
  account,
  showInstructions = () => {},
  goBack = () => {},
}) {
  const url = "chrome://extensions/";

  return (
    <View style={[appStyles.container, { backgroundColor: "#FFF" }]}>
      <Header
        title="Reconnect Chrome"
        subTitle={account}
        goBack={goBack}
        returnPage={appPages.integrationsV2}
      />

      <ScrollView
        style={(appStyles.scrollView, { paddingHorizontal: 16 })}
        contentContainerStyle={appStyles.scrollViewContent}
      >
        <Text style={styles.sectionText}>
          We’re having trouble connecting to your account
        </Text>

        <Text style={styles.label}>Reconnect Chrome Extension:</Text>

        <Text style={styles.text}>
          1. Copy the link below into your browser:
        </Text>

        <CopyWidget
          text={url}
          style={{
            marginTop: 8,
            marginBottom: 16,
          }}
        />

        <Text style={[styles.text, { marginBottom: 8 }]}>
          2. Scroll down until you see Mana, and ensure that the toggle is on
        </Text>

        <Text style={[styles.text, styles.linkText]} onPress={showInstructions}>
          3. If you don’t see Mana, click here for instructions to reinstall the
          Chrome Extension
        </Text>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  label: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#8B92A1",
    marginBottom: 8,
    marginTop: 16,
  },
  text: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
  linkText: {
    color: AppTheme.DEFAULT_COLOR,
    fontWeight: "600",
    marginBottom: 8,
  },
  sectionText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: MoodColors.VeryBad,
    marginTop: 16,
    textAlign: "center",
  },
});
